import React from "react";
import "../../css/sharedStyles.css";
import VideosPageContainer from "../videosPage/videosPageContainer.js";

var VideosPageLayout = class VideosPageLayout extends React.Component{
    
    constructor(props) {
        super(props);
      }  



      componentDidMount(){
        this.props.changeCurrentPage("videos")
      }//end componentDidMount() 
    
    
    render() {
      const inlineStyle = {
        
      }
      
      return (
        <div className = "content_box_square">
            < VideosPageContainer 
                characterInfo = {this.props.characterInfo}  
                videoInfo = {this.props.videoInfo}
                showVideos = {this.props.showVideos}
                changeVideos = {this.props.changeVideos}
                changeSelectedVideo = {this.props.changeSelectedVideo}
                changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
            />
            
            

        </div>
      );
    }
  }

  export default VideosPageLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/videosPageLayout.js